import { CatList } from '@blocks-react/components/List';
import styles from '../DIY.module.scss';
import { VideoListProps } from '../types';
import cx from 'classnames';
import { DIYVideo } from '../diy-video';
import { CatListItem } from '@blocks-react/components/ListItem';
export const VideoList = ({ classname, videoLists }: VideoListProps) => {
  return (
    <CatList
      behavior="overflow"
      orientation="horizontal"
      spacing="condensed"
      className={styles['cat-c-list']}
    >
      {videoLists.map((item) => {
        return (
          <CatListItem
            key={item.id}
            className={cx(
              'p-0 mb-3 ps-1 pt-3 ms-n1',
              styles['cat-c-listItems'],
              classname
            )}
          >
            <div
              className={cx(
                'd-block px-3 py-3',
                styles['c-video-section__listItem-container'],
                videoLists.length === 1
                  ? styles['c-video-section__single-listItem-container']
                  : styles['c-video-section__multiple-listItem-container']
              )}
            >
              <DIYVideo
                item={item}
                classname={cx(
                  styles['c-video-section__griditem'],
                  videoLists.length === 1 &&
                    styles['c-video-section__single_listItem']
                )}
              />
            </div>
          </CatListItem>
        );
      })}
    </CatList>
  );
};
